export const INJURY_REPORT_STATUS_IDS = {
  ALL: -1,
  NEW: 0,
  PENDING_MANAGER: 1,
  APPROVED_MANAGER: 2,
  REJECTED_MANAGER: 3,
  ASSET_IN_TRANSIT: 4,
}

export const statusFilterOptions = [
  { value: INJURY_REPORT_STATUS_IDS.ALL, label: 'ALL' },
  { value: INJURY_REPORT_STATUS_IDS.PENDING_MANAGER, label: 'PENDING_MANAGER' },
  { value: INJURY_REPORT_STATUS_IDS.APPROVED_MANAGER, label: 'APPROVED_MANAGER' },
  { value: INJURY_REPORT_STATUS_IDS.REJECTED_MANAGER, label: 'REJECTED_MANAGER' },
]
